<template>
    <el-dialog class="el-dialogs" append-to-body :title="title" width="1100px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row :gutter="20">
            <el-col :span="10" class="borderStyle">
                <div class="bodTitle">选择数据</div>
                <div class="flex_l_c magTops">
                    <el-input v-model.trim="keyworld" maxlength="20"
                              placeholder="请输入关键字(限20字)"
                              suffix-icon="el-icon-search" size="mini"
                              style="width: 200px"
                              @input="fileterData"
                    ></el-input>
                    <div style="margin-left: 15px;">
                        <el-checkbox-group v-model="checkList" @change="setNodeNameList()">
                            <el-checkbox label="1">我的节点</el-checkbox>
                            <el-checkbox label="2">节点管理</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <el-table
                        :data="keyworld.length ? searchFilData : searchData"
                        v-loading="leftLoading"
                        size="small" height="423px"
                        class="table magTops" border
                        ref="leftMultipleTable"
                        :row-key="'id'"
                        @selection-change="leftSelectHandle"
                >
                    <el-table-column :reserve-selection="true" :selectable="selectable" type="selection" width="50"/>
                    <el-table-column prop="knowledgeName" label="节点名称" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <div>{{ row.knowledgeName + ' -' + row.userName }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                </el-table>
            </el-col>
            <el-col :span="4">
                <div class="middleBotn">
                    <div style="margin-bottom: 30px">
                        <el-button size="small" type="primary" @click="selectData()">选择数据<i
                                class="el-icon-arrow-right"></i></el-button>
                    </div>
                    <div>
                        <el-button size="small" icon="el-icon-arrow-left" @click="deselectData()">取消选择</el-button>
                    </div>
                </div>
            </el-col>
            <el-col :span="10" class="borderStyle">
                <div class="bodTitle">已选择数据</div>
                <el-table
                        :data="rigthDataList"
                        size="small" height="463px"
                        class="table magTops" border
                        ref="rightMultipleTable"
                        :row-key="'id'"
                        @selection-change="rigthSelectHandle"
                >
                    <el-table-column :reserve-selection="true" type="selection" width="50"/>
                    <el-table-column prop="knowledgeName" label="节点名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "addBatchData",
    components: {},
    data() {
        return {
            title: '批量新增节点',
            visible: false,
            keyworld: '',
            checkList: ['1', '2'],

            leftDataList: [],
            leftLoading: false,
            leftSelectList: [],
            searchData: [],
            searchFilData: [],

            rigthDataList: [],
            rigthSelectList: [],

            listSetlectData: {},
        }
    },
    methods: {
        init(listSetlectData) {
            this.visible = true
            this.keyworld = ''
            this.rigthDataList = []
            this.listSetlectData = listSetlectData
            this.setNodeNameList()
        },

        fileterData() {
            this.$refs.leftMultipleTable.clearSelection()
            if (this.keyworld !== '') {
                this.searchFilData = this.searchData.filter(item => {
                    return item.knowledgeName.toLowerCase().indexOf(this.keyworld.toLowerCase()) > -1;
                });
            } else {
                this.searchFilData = []
            }
        },

        //获取没有使用的节点
        setNodeNameList() {
            this.$nextTick(() => {
                this.$refs.leftMultipleTable.clearSelection()
            })
            if (this.checkList.length > 0) {
                if (this.checkList.length == 1) {
                    if (this.checkList[0] == 2) {
                        this.getOtherData('common')
                    } else {
                        this.getOtherData('mine')
                    }
                } else {
                    this.getOtherData('mine', 'common')
                }
            }else {
                this.leftDataList = []
                this.searchData = []
            }
        },

        //name mine我的节点 common公共节点
        getOtherData(name, name2) {
            let data
            if (!name2) {
                data = {
                    [name]: 1,
                }
            } else {
                data = {
                    [name]: 1,
                    [name2]: 1,
                }
            }
            this.leftLoading = true
            this.$axios(this.api.academic.knowledgenodeKnowledgeGraphNodeList, {
                ...data,
                knowledgeId: this.listSetlectData.id
            }, 'get').then(data => {
                if (data && data.status) {
                    this.leftDataList = data.data
                    this.searchData = this.leftDataList
                    this.rigthDataList = []
                    this.leftLoading = false
                }
            })
        },

        //左侧表格选择
        leftSelectHandle(val) {
            this.leftSelectList = val
        },

        selectable(row, index) {
            if (row.knowledgeId) {
                return false
            } else {
                return true
            }
        },

        //右侧表格选择
        rigthSelectHandle(val) {
            this.rigthSelectList = val
        },

        //选择数据
        selectData() {
            if (this.leftSelectList.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this.rigthDataList.push(...this.leftSelectList)
            this.$refs.leftMultipleTable.clearSelection()
            this.reasetTwoData()
        },

        //重置左右表展示数据
        reasetTwoData() {
            this.searchData = this.leftDataList.filter(item => !this.rigthDataList.includes(item))
        },

        //取消选择数据
        deselectData() {
            if (this.rigthSelectList.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this.rigthDataList = this.rigthDataList.filter(item => !this.rigthSelectList.includes(item))
            this.$refs.rightMultipleTable.clearSelection()
            this.reasetTwoData()
        },

        //提交
        doSubmit() {
            if (!this.rigthDataList.length) {
                this.$message.warning('请至少选择一个节点')
                return
            }
            let nodeIds = this.rigthDataList.map(item => {
                return item.id
            })
            this.$axios(this.api.academic.knowledgegraphnodeBatchSave, {
                nodeIds,
                knowledgeId: this.listSetlectData.id,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('保存成功')
                    this.visible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.el-dialogs::v-deep .el-dialog__body {
  height: auto !important;

  .el-row {
    padding: 0 10px !important;
  }
}

.borderStyle {
  border: 1px solid #EBEBEB;
  padding: 10px;
  border-radius: 10px;

  .bodTitle {
    font-size: 14px;
    font-weight: bold;
  }
}

.magTops {
  margin-top: 10px;
}

.middleBotn {
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
